export const URL_BASE = 'https://www.deckblox.app/';
export const URL_OVERLAYS = 'https://www.deckblox.app/overlay';